
import XImg from 'vux/src/components/x-img/index.vue'

export default {
name: 'productPage',
components: {
XImg
},
data () {
return {
imgSrc: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/cpjs04.jpg'
}
}
}



// WEBPACK FOOTER //
// ./src/pages/user/productPage.vue